import { useQuery } from "@tanstack/react-query";
import { MenuFragment } from "./fragments/menu";
import { useLocationId } from "~/store";
import { GetActiveMenuDocument } from "~/types/__generated/gql/graphql";
import { validateSessionFromUrl } from "~/utils/validate-session-from-url";
import { gqlReq } from "~/libs/gql";

void (
	/* GraphQL */ `
		query GetActiveMenu {
			getActiveMenu {
				...MenuFragment
			}
		}
		${MenuFragment}
	`
);

export const getActiveMenuQueryKey = () => ["menu"];

export const useGetActiveMenu = () => {
	const locationId = useLocationId();

	return useQuery({
		enabled: !!locationId,
		queryKey: getActiveMenuQueryKey(),
		queryFn: ({ signal }) => {
			const { isSessionExpired, isPathnameSessionSensitive } =
				validateSessionFromUrl();
			if ((isPathnameSessionSensitive() && isSessionExpired()) || !locationId)
				return Promise.resolve(undefined);
			return gqlReq({
				document: GetActiveMenuDocument,
				signal,
			});
		},
	});
};
